import { Toast } from "devextreme-react";
import { ToastInfo } from "../shared/models/ToastInfo";

interface Props {
  toastInfo: ToastInfo;
  onHiding: () => void;
}

const ToastMessage = ({ toastInfo, onHiding }: Props) => {
  return (
    <>
      <Toast
        position={"top"}
        maxWidth={900}
        maxHeight={40}
        visible={toastInfo.isShow}
        message={toastInfo.text}
        onHiding={onHiding}
        type={toastInfo.type}
        displayTime={toastInfo.type === "error" ? 90000 : 5000}
        closeOnClick={true}
      />
    </>
  );
};

export default ToastMessage;
